<template lang="pug">
  yz-card.pa-6(outlined)
    .yz-heading-9 {{ $t('panel.eligible_staffs') }}
    .yz-regular-body-xs.mb-5 {{ $t('panel.eligible_staffs_description') }}

    // Error State
    div(v-if="isError")
      yz-empty-state-card(icon="mdi-alert-circle-outline" icon-color="yz-danger-500" :title="$t('error_message.unable_to_load_data')" :description="$t('error_message.please_try_again')" action-label="Retry" @action-click="fetchStaffs")

    // Empty State
    div(v-else-if="!isLoadingStaff && staffData.length === 0")
      yz-empty-state-card(icon="$yzi-users-02" icon-color="yz-neutral-500" :title="$t('panel.no_eligible_staff_found')" :description="$t('panel.eligible_staff_will_appear_here')")

    // Loading State
    div(v-else-if="isLoadingStaff")
      yz-skeleton-loader(type="table-thead")
      yz-skeleton-loader(type="table-tbody")

    // Main Content
    yz-data-table(v-else :headers="staffHeaders" :items="staffData" item-key="id" disable-sort)
      template(v-slot:item.name="{ item }")
        span(:class="item.name === 'N/A' ? 'text-neutral-500' : ''") {{ item.name }}

      template(v-slot:item.nric="{ item }")
        span(:class="item.nric === 'N/A' ? 'text-neutral-500' : ''") {{ item.nric }}

      template(v-slot:item.staffId="{ item }")
        span(:class="item.staffId === 'N/A' ? 'text-neutral-500' : ''") {{ item.staffId }}

      template(v-slot:item.phoneNumber="{ item }")
        span(:class="item.phoneNumber === 'N/A' ? 'text-neutral-500' : ''") {{ item.phoneNumber }}

      template(v-slot:item.email="{ item }")
        span(:class="item.email === 'N/A' ? 'text-neutral-500' : ''") {{ item.email }}

      template(v-slot:item.actions="{ item }")
        yz-menu(offset-y close-on-click left)
          template(v-slot:activator="{ on, attrs }")
            yz-btn(icon-only, icon-color="yz-neutral-500" v-bind="attrs" v-on="on" icon="$yzi-dots-horizontal")
          yz-list
            yz-list-item(@click="onViewStaff(item)")
              div {{ $t('panel.view_staff_details') }}

    yz-pagination.mt-4(v-if="!isError && staffData.length > 0" v-model="staffTableOptions.page" :page-size.sync="staffTableOptions.itemsPerPage" :count="staffTableOptions.totalItems" type="item" arrow, @input="fetchStaffs")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    parentPanelId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      isLoadingStaff: false,
      isError: false,

      staffHeaders: [
        { text: this.$t('panel.name'), value: 'name' },
        { text: this.$t('panel.nric'), value: 'nric' },
        { text: this.$t('panel.staff_id_field'), value: 'staffId' },
        { text: this.$t('panel.phone_number'), value: 'phoneNumber' },
        { text: this.$t('panel.email'), value: 'email' },
        { text: '', value: 'actions', align: 'end', sortable: false }
      ],
      staffTableOptions: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      },
      staffData: []
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' })
  },
  mounted() {
    if (this.parentPanelId) {
      this.fetchStaffs()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchStaffs() {
      this.isLoadingStaff = true
      this.isError = false
      const params = {
        page: this.staffTableOptions.page,
        page_size: this.staffTableOptions.itemsPerPage,
        fields: 'id,name,panels,staff_id,ic,phone,email',
        panels: this.parentPanelId
      }

      try {
        const response = await this.$axios.get(`/clinics/${this.company.slug}/patients/`, { params })
        this.staffData = response.data.results.map(patient => ({
          ...patient,
          nric: patient.ic || 'N/A',
          staffId: patient.staff_id || 'N/A',
          phoneNumber: patient.phone || 'N/A',
          email: patient.email || 'N/A'
        }))
        this.staffTableOptions.totalItems = response.data.count
      } catch (error) {
        console.error('Error fetching staff:', error)
        this.isError = true
        await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoadingStaff = false
      }
    },
    onViewStaff(staff) {
      const route = this.$router.resolve(`/admin/clinic/patient/${staff.id}`)
      window.open(route.href, '_blank')
    }
  }
}
</script>

<style scoped></style>
